<div class="flex w-full flex-col gap-2">
  <p class="text-md !mb-0 font-bold">{{ label }}</p>
  <form class="flex flex-row gap-2" [formGroup]="form">
    <mat-form-field
      class="w-full"
      subscriptSizing="dynamic"
      floatLabel="always"
    >
      <mat-label>Amount</mat-label>
      <input
        matInput
        formControlName="amount"
        type="number"
        min="1"
        placeholder="{{ defaultPlaceholder }}"
      />
    </mat-form-field>

    <mat-form-field
      class="w-full"
      subscriptSizing="dynamic"
      floatLabel="always"
    >
      <mat-label>Unit</mat-label>
      <mat-select formControlName="unit" placeholder="Days">
        @for (unit of timingUnits; track unit) {
          <mat-option [value]="unit"> {{ unit | titlecase }} </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (form.value.amount || form.value.unit) {
      <button
        type="button"
        mat-icon-button
        matTooltip="Clear Restriction"
        aria-label="Clear"
        (click)="clearForm()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </form>
  @if (form.hasError('maxBookingWindow') && form.touched) {
    <p class="text-xs text-red-600">
      Maximum booking window cannot exceed {{ maxBookingWindowDays }} days.
    </p>
  }
  <p class="text-xs">{{ hint }}</p>
</div>
